import { z } from 'zod';
import { EmailSchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema } from './shared.js';
export const UserRoleSchema = z.enum(['superAdmin', 'opsAdmin', 'viewAdmin', 'tech', 'salesRep']);
export const UserRoleAssignmentStateSchema = z.enum(['active', 'revoked']);
export const UserRoleAssignmentSchema = z.object({
    id: IDSchema,
    type: z.literal('user_role_assignment'),
    schemaVersion: SchemaVersionSchema,
    userEmail: EmailSchema,
    role: UserRoleSchema,
    state: UserRoleAssignmentStateSchema.default('active'),
    grantedAt: IsoTimestampSchema,
    grantedBy: z.string(),
    grantedReason: z.string().optional(),
    revokedAt: IsoTimestampSchema.optional(),
    revokedBy: z.string().optional(),
    revokedReason: z.string().optional(),
    entraGroupId: z.string(),
    entraSyncedAt: IsoTimestampSchema.optional(),
    entraOutOfSync: z.boolean().default(false),
    // ─── Team scoping (T-TEAM-001-FOUNDATION; data model §20 addendum) ─────────
    // These apply ONLY to `role='opsAdmin'` rows. Account visibility for an
    // opsAdmin is derived at query time (§21 inheritance rule):
    //   companyWide=true            → sees ALL Accounts
    //   else scopeTeamIds: string[] → sees Accounts whose assigned rep is a
    //                                 current member of any of these teams.
    // superAdmin is implicitly companyWide (Q3); salesRep membership lives on
    // user_team_memberships (§22), NOT here. Enforcement is gated by
    // `enforceTeamScoping` (default false / legacy: opsAdmin sees all) — flipped
    // by T5-FLAG-PLUMBING-TEAM-SCOPING after Teams are populated + tested.
    scopeTeamIds: z.array(IDSchema).default([]),
    companyWide: z.boolean().default(false),
    createdAt: IsoTimestampSchema,
    updatedAt: IsoTimestampSchema,
    version: z.number().int().positive(),
});
//# sourceMappingURL=user-role-assignment.js.map